import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const SEVERITY_COLORS = {
  Critical: '#d32f2f',
  High: '#f57c00',
  Medium: '#1976d2',
  Low: '#388e3c'
};

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const total = payload.reduce((sum, e) => sum + (e.value || 0), 0);
  return (
    <Paper sx={{ p: 1, border: '1px solid #ccc' }}>
      <Typography variant="body2" fontWeight="bold">{label}</Typography>
      {payload.map((entry, i) => (
        <div key={i} style={{ color: entry.color }}>{entry.name}: {entry.value}</div>
      ))}
      <Typography variant="body2" fontWeight="bold" mt={0.5}>Total: {total}</Typography>
    </Paper>
  );
};

const SnykIncomingBySeverityChart = ({ data = [], onBarClick }) => {
  if (!data.length) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" height={300}>
        <Typography color="text.secondary">No data available</Typography>
      </Box>
    );
  }

  const clickable = Boolean(onBarClick);

  return (
    <Box>
      {clickable && (
        <Typography variant="caption" color="text.secondary" display="block" align="center" mb={1}>
          Click any bar segment to drill down into those issues
        </Typography>
      )}
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="period" tick={{ fontSize: 11 }} interval="preserveStartEnd" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          {['Critical', 'High', 'Medium', 'Low'].map(sev => (
            <Bar
              key={sev}
              dataKey={sev}
              name={sev}
              stackId="a"
              fill={SEVERITY_COLORS[sev]}
              style={{ cursor: clickable ? 'pointer' : 'default' }}
              onClick={clickable ? (d) => onBarClick({ period: d.period, severity: sev }) : undefined}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default SnykIncomingBySeverityChart;
